import { useState } from 'react';
import {
  createBrowserRouter, isRouteErrorResponse, Link, NavLink, Outlet, RouterProvider, ScrollRestoration, useRouteError,
} from 'react-router';
import { useYo } from './api/hooks';
import { aplicarTema, ETIQUETA_TEMA, leerTema, siguienteTema, type Tema } from './lib/tema';
import Ajustes from './pantallas/Ajustes';
import Catalogo from './pantallas/Catalogo';
import { ClienteDetallePantalla, ClientesPantalla } from './pantallas/Clientes';
import Programa from './pantallas/Programa';
import Reportes from './pantallas/Reportes';
import TrabajoDetalle from './pantallas/TrabajoDetalle';
import Trabajos from './pantallas/Trabajos';
import { useSesion } from './sesion';

const SECCIONES = [
  { a: '/', texto: 'Trabajos', fin: true },
  { a: '/programa', texto: 'Programa' },
  { a: '/clientes', texto: 'Clientes' },
  { a: '/reportes', texto: 'Reportes' },
  { a: '/catalogo', texto: 'Catálogo' },
  { a: '/ajustes', texto: 'Ajustes' },
];

function Nav() {
  return (
    <nav className="nav" aria-label="Secciones">
      {SECCIONES.map((s) => (
        <NavLink key={s.a} to={s.a} end={s.fin} className={({ isActive, isPending }) => (isActive || isPending ? 'active' : undefined)}>
          {s.texto}
        </NavLink>
      ))}
    </nav>
  );
}

function BotonTema() {
  const [tema, setTema] = useState<Tema>(leerTema);
  const icono = tema === 'oscuro' ? '☾' : tema === 'claro' ? '☀' : '◐';
  return (
    <button type="button" className="btn btn--sm btn--fantasma" title={ETIQUETA_TEMA[tema]} aria-label={ETIQUETA_TEMA[tema]}
      onClick={() => { const t = siguienteTema(tema); aplicarTema(t); setTema(t); }}>
      <span aria-hidden="true" style={{ fontSize: '1rem' }}>{icono}</span>
    </button>
  );
}

function Marco() {
  const { modo, Controles } = useSesion();
  const yo = useYo();
  return (
    <>
      <header className="cabecera">
        <div className="wrap">
          <div className="cabecera__top">
            <Link to="/" className="marca">
              <small>{yo.data?.tenant.nombre ?? 'Emisha'} · Taller</small>
              <b>Láser</b>
            </Link>
            <Nav />
            <div className="grow" />
            {modo === 'mock' && <span className="modo" title="VITE_MOCK=1: datos en memoria, nada se guarda">Datos de prueba</span>}
            {modo === 'dev' && <span className="modo" title="Sin VITE_CLERK_PUBLISHABLE_KEY: se manda Authorization: Bearer dev">Modo desarrollo</span>}
            <BotonTema />
            {Controles && <Controles />}
          </div>
          <div className="cabecera__nav-movil"><Nav /></div>
        </div>
      </header>
      <main className="wrap">
        <Outlet />
      </main>
      <ScrollRestoration />
    </>
  );
}

function ErrorRuta() {
  const e = useRouteError();
  const titulo = isRouteErrorResponse(e) && e.status === 404 ? 'No encontramos esta página' : 'Algo falló al mostrar esta pantalla';
  return (
    <main className="wrap" style={{ paddingTop: 40 }}>
      <div className="tarjeta pila" style={{ maxWidth: 520 }}>
        <h1 style={{ fontSize: '1.2rem' }}>{titulo}</h1>
        <p className="muted">{e instanceof Error ? e.message : isRouteErrorResponse(e) ? e.statusText : ''}</p>
        <p><Link className="btn" to="/">Volver a trabajos</Link></p>
      </div>
    </main>
  );
}

const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <Marco />,
      errorElement: <ErrorRuta />,
      children: [
        { index: true, element: <Trabajos /> },
        { path: 'trabajos/:id', element: <TrabajoDetalle /> },
        { path: 'programa', element: <Programa /> },
        { path: 'clientes', element: <ClientesPantalla /> },
        { path: 'clientes/:id', element: <ClienteDetallePantalla /> },
        { path: 'reportes', element: <Reportes /> },
        { path: 'catalogo', element: <Catalogo /> },
        { path: 'ajustes', element: <Ajustes /> },
        { path: '*', element: <ErrorRuta /> },
      ],
    },
  ],
  { basename: import.meta.env.BASE_URL.replace(/\/$/, '') || '/' },
);

export default function App() {
  return <RouterProvider router={router} />;
}
